import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { ErrorCode } from "react-dropzone";
export var errorMessages = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ErrorCode.FileInvalidType, "upload/file-invalid-type"), ErrorCode.FileTooLarge, "upload/file-too-large"), ErrorCode.FileTooSmall, "upload/file-too-small"), ErrorCode.TooManyFiles, "upload/too-many-files");
export var getErrorMessage = function getErrorMessage(code) {
  var errorMessage = errorMessages[code] || "Unknown error";
  return errorMessage;
};